import { v4 as uuidv4 } from 'uuid';
import MemLearning from '@memrise/memlearning';

// Stubbed for now. Real implementation to be added in WEBSITE-2015
export const eventManager = {
  track: () => {
    /* do nothing */
  },
  randomUUID: uuidv4,
};

// Stubbed for now. Real implementation to be added in WEBSITE-2015
// Doesn't actually do anything yet due to empty track function above.
export const trackingContext = new MemLearning.com.memrise.learning.session.events.TrackingContext(
  new MemLearning.com.memrise.learning.models.CourseContentStructure(
    9999, // courseId
    9999 // levelId
  ),
  MemLearning.com.memrise.foundation.makeEnum('SourceElement', 'scb'),
  MemLearning.com.memrise.foundation.makeEnum('SourceScreen', 'unknown_source_screen'),
  9999, // numItemsToReview
  null,
  null,
  null,
);
